export const colleagueDomains = [
  'sainsburys.co.uk',
  'nectar360.co.uk',
  'sainsburys.com.hk',
  'sainsburysbank.co.uk',
];
